import React from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import style from './index.module.scss';
import Typography from '@mui/material/Typography';
import { useTranslate } from 'hooks/use-translate';

export const EmployeeMonitorItemEmpty: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { tp } = useTranslate();
  return (
    <div className={style.root}>
      <AccountCircleOutlinedIcon fontSize={'inherit'} className={style.icon} />
      <Typography color={'secondary'}> {tp('employee-activities-monitor-items-empty')}</Typography>
    </div>
  );
};
